import { svg } from "lit";

export function linkIcon() {
  return svg`<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.665 4.66406V0.664062H8.66504M12.665 0.664062L5.33171 7.9974M10.665 7.33073V11.3307C10.665 11.6844 10.5246 12.0235 10.2745 12.2735C10.0245 12.5236 9.68533 12.6641 9.33171 12.6641H1.99837C1.64475 12.6641 1.30561 12.5236 1.05556 12.2735C0.805515 12.0235 0.665039 11.6844 0.665039 11.3307V3.9974C0.665039 3.64377 0.805515 3.30464 1.05556 3.05459C1.30561 2.80454 1.64475 2.66406 1.99837 2.66406H5.99837" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
}
